import * as React from 'react';

import { cn } from '@/lib/utils';
import { cva } from 'class-variance-authority';

const inputVariants = cva(
  'flex w-full min-w-0 rounded-full border border-grey-300 hover:border-grey-400 bg-white text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-neutral-900 selection:text-neutral-50 file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-neutral-950 placeholder:text-grey-300 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-grey-100 md:text-sm dark:border-neutral-800 dark:bg-neutral-200/30 dark:dark:bg-neutral-800/30 dark:selection:bg-neutral-50 dark:selection:text-neutral-900 dark:file:text-neutral-50 dark:placeholder:text-neutral-400 focus-visible:border-purple-500 aria-invalid:border-red-600 dark:aria-invalid:border-red-900',
  {
    variants: {
      size: {
        default: 'h-10 px-3 py-1 txt-md',
        sm: 'h-8 px-3 py-1 txt-sm',
        lg: 'h-12 px-3 py-1 txt-md'
      }
    },
    defaultVariants: {
      size: 'default'
    }
  }
);

function Input({ className, type, size, ...props }) {
  return <input type={type} data-slot="input" className={cn(inputVariants({ size, className }))} {...props} />;
}

export { Input };
